import { useEffect, useState } from "react";

// Seconds to wait before an emailed code may be sent again (the backend
// refuses earlier sends with the same wait).
export const RESEND_WAIT_SECONDS = 120;

// 118 -> "1:58"
export const formatCountdown = (seconds) =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;

// Counts down once a second; start(seconds) restarts it.
export default function useResendCountdown(initialSeconds = 0) {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    if (secondsLeft <= 0) return undefined;
    const timer = setTimeout(() => setSecondsLeft((left) => left - 1), 1000);
    return () => clearTimeout(timer);
  }, [secondsLeft]);

  return [secondsLeft, setSecondsLeft];
}
